const FONTS_CONFIG = {
  // Google Fonts
  playfair_display: {
    label: "Playfair Display",
    css: "'Playfair Display', serif",
    googleFont: "Playfair Display",
  },
  montserrat: {
    label: "Montserrat",
    css: "'Montserrat', sans-serif",
    googleFont: "Montserrat",
  },
  lora: {
    label: "Lora",
    css: "'Lora', serif",
    googleFont: "Lora",
  },
  poppins: {
    label: "Poppins",
    css: "'Poppins', sans-serif",
    googleFont: "Poppins",
  },
  inter: {
    label: "Inter",
    css: "'Inter', sans-serif",
    googleFont: "Inter",
  },
  raleway: {
    label: "Raleway",
    css: "'Raleway', sans-serif",
    googleFont: "Raleway",
  },
  opensans: {
    label: "Open Sans",
    css: "'Open Sans', sans-serif",
    googleFont: "Open Sans",
  },
  dancing_script: {
    label: "Dancing Script",
    css: "'Dancing Script', cursive",
    googleFont: "Dancing Script",
  },
  great_vibes: {
    label: "Great Vibes",
    css: "'Great Vibes', cursive",
    googleFont: "Great Vibes",
  },
  bebas_neue: {
    label: "Bebas Neue",
    css: "'Bebas Neue', sans-serif",
    googleFont: "Bebas Neue",
  },
  pacifico: {
    label: "Pacifico",
    css: "'Pacifico', cursive",
    googleFont: "Pacifico",
  },
  lexend: {
    label: "Lexend",
    css: "'Lexend', sans-serif",
    googleFont: "Lexend",
  },
  source_serif_pro: {
    label: "Source Serif Pro",
    css: "'Source Serif Pro', serif",
    googleFont: "Source Serif Pro",
  },

  // System fonts (fallback, no Google Font needed)
  georgia: {
    label: "Georgia",
    css: "Georgia, serif",
  },
  times_new_roman: {
    label: "Times New Roman",
    css: "'Times New Roman', Times, serif",
  },
  verdana: {
    label: "Verdana",
    css: "Verdana, sans-serif",
  },
  arial: {
    label: "Arial",
    css: "Arial, sans-serif",
  },
  helvetica: {
    label: "Helvetica",
    css: "'Helvetica Neue', Helvetica, sans-serif",
  },
};

/**
 * Get font config by key
 * @param {string} fontKey - The font identifier
 * @returns {Object} Font configuration or fallback to system font
 */
export const getFontConfig = (fontKey) => {
  if (!fontKey || typeof fontKey !== "string") {
    return FONTS_CONFIG.montserrat; // Default fallback
  }

  const config = FONTS_CONFIG[fontKey];
  return config || FONTS_CONFIG.montserrat;
};

/**
 * Get all available fonts for dropdown
 * @returns {Array} Array of font options for select dropdowns
 */
export const getFontOptions = () => {
  return Object.entries(FONTS_CONFIG).map(([key, config]) => ({
    value: key,
    label: config.label,
  }));
};

/**
 * Generate Google Fonts import URL
 * @param {Array} fontKeys - Array of font keys to load
 * @returns {string} URL string for Google Fonts API
 */
export const generateGoogleFontsUrl = (fontKeys) => {
  const fonts = fontKeys
    .map((key) => getFontConfig(key))
    .filter((config) => config.googleFont)
    .map((config) => {
      // Replace spaces with + for URL encoding
      const fontName = config.googleFont.replace(/\s+/g, "+");
      // Add weight variants: 400, 600, 700 for better typography
      return `${fontName}:wght@400;600;700`;
    });

  // Remove duplicates
  const uniqueFonts = [...new Set(fonts)];

  if (uniqueFonts.length === 0) return "";

  return `https://fonts.googleapis.com/css2?${uniqueFonts
    .map((f) => `family=${f}`)
    .join("&")}&display=swap`;
};

/**
 * Load Google Fonts dynamically
 * @param {Array} fontKeys - Array of font keys to load
 */
export const loadGoogleFonts = (fontKeys) => {
  const url = generateGoogleFontsUrl(fontKeys);

  if (!url) return;

  // Check if already loaded
  if (document.querySelector(`link[href="${url}"]`)) {
    return;
  }

  const link = document.createElement("link");
  link.href = url;
  link.rel = "stylesheet";
  document.head.appendChild(link);
};

export { FONTS_CONFIG };
